import { useState } from 'react'
import PropTypes from 'prop-types'

export default function HamburgerButton({ onClick, className, thin }) {
  const [open, setOpen] = useState(false)

  const handleClick = () => {
    setOpen(!open)
    onClick(!open)
  }

  return (
    <button
      className={`tw-custom-button-reset tw-p-2 ${className}`}
      aria-label="menu-button"
      onClick={handleClick}>
      <span
        className={`tw-bg-header-burger tw-block ${
          thin ? 'tw-h-2px tw-w-6' : 'tw-h-1 tw-w-8'
        } tw-mb-1 tw-ease-in-out tw-duration-200 ${
          open
            ? thin
              ? 'tw-custom-transform-thin-burger-0'
              : 'tw-custom-transform-burger-0'
            : ''
        }`}></span>
      <span
        className={`tw-bg-header-burger tw-block ${
          thin ? 'tw-h-2px tw-w-6' : 'tw-h-1 tw-w-8'
        } tw-mb-1 tw-ease-in-out tw-duration-200 ${
          open ? 'tw-custom-scale-0' : ''
        }`}></span>
      <span
        className={`tw-bg-header-burger tw-block ${
          thin ? 'tw-h-2px tw-w-6' : 'tw-h-1 tw-w-8'
        } tw-ease-in-out tw-duration-200 ${
          open
            ? thin
              ? 'tw-custom-transform-thin-burger-1'
              : 'tw-custom-transform-burger-1'
            : ''
        }`}></span>
    </button>
  )
}

HamburgerButton.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  thin: PropTypes.bool,
}
